// extracted by mini-css-extract-plugin
module.exports = {"container":"TdAutoGenerate_container__1HW9S","input":"TdAutoGenerate_input__2kzdA"};